import { OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { LogManager } from "../../common/log/log.manager";
import { LogCat } from "../../common/log/log.categories";
import * as i0 from "@angular/core";
import * as i1 from "./auth-token-refresher.service";
import * as i2 from "./auth-provider.proxy";
import * as i3 from "@angular/router";
var AuthProviderService = /** @class */ (function () {
    function AuthProviderService(tokenRefresher, authProviderProxy, router) {
        this.tokenRefresher = tokenRefresher;
        this.authProviderProxy = authProviderProxy;
        this.router = router;
        this.currentTokenSubject = new BehaviorSubject(undefined);
        this.currentPatientSubject = new BehaviorSubject(undefined);
        this.loginWatcher$ = this.currentTokenSubject.asObservable();
    }
    AuthProviderService.prototype.ngOnDestroy = function () { };
    AuthProviderService.prototype.logout = function (reason) {
        var _this = this;
        this.router.navigate(['/login']).then(function () {
            if (_this.currentUserToken) {
                var token = _this.currentUserToken.access_token;
                var refreshToken = _this.currentUserToken.refresh_token;
                _this.tokenRefresher.invalidateRefreshToken(refreshToken).subscribe(function () {
                    LogManager.debug(LogCat.Login.TokenRefresh, "Invalidated refresh token for logged out user");
                }, function (err) {
                    LogManager.error(LogCat.Login.TokenRefresh, "Failed to invalidate refresh token for logged out user", err);
                });
                _this.tokenRefresher.Stop();
                _this.setPatient(null);
                _this.setToken(null);
                _this.authProviderProxy.logout(reason, token).subscribe();
            }
        });
    };
    Object.defineProperty(AuthProviderService.prototype, "currentUserToken", {
        get: function () {
            return this.currentTokenSubject.value != null ? this.currentTokenSubject.value : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthProviderService.prototype, "currentPatient", {
        get: function () {
            return this.currentPatientSubject.value;
        },
        enumerable: true,
        configurable: true
    });
    AuthProviderService.prototype.isAuthenticated = function () {
        return !(this.currentTokenSubject.value == null || this.currentPatientSubject.value == null);
    };
    /* set auth token and return subscription to logged in patient */
    AuthProviderService.prototype.setCredentials = function (token) {
        var _this = this;
        this.setToken((token));
        this.startRefresher(token);
        var subjPatient = new Subject();
        subjPatient.subscribe(function (patient) {
            _this.setPatient(patient);
            subjPatient.complete();
        });
        return subjPatient;
    };
    AuthProviderService.prototype.setAccountPreference = function (key) {
        var patient = this.currentPatient;
        patient.accountPreferences.defaultLanguageKey = key;
        this.setPatient(patient);
    };
    AuthProviderService.prototype.startRefresher = function (token) {
        var _this = this;
        if (token.refresh_token) {
            this.tokenRefresher.StartRefresh(token).subscribe(function (newToken) {
                _this.setToken((newToken));
            });
        }
    };
    AuthProviderService.prototype.setToken = function (token) {
        if (token == null) {
            this.currentTokenSubject.next(null);
        }
        else {
            this.currentTokenSubject.next(token);
            LogManager.setCredentials(token.access_token);
        }
    };
    AuthProviderService.prototype.setPatient = function (patient) {
        this.currentPatientSubject.next(patient);
    };
    AuthProviderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthProviderService_Factory() { return new AuthProviderService(i0.ɵɵinject(i1.AuthTokenRefresherService), i0.ɵɵinject(i2.AuthProviderProxy), i0.ɵɵinject(i3.Router)); }, token: AuthProviderService, providedIn: "root" });
    return AuthProviderService;
}());
export { AuthProviderService };
